import React from "react";
import { PLAYER_IMAGE_POSES } from "../../constants/general";
import PlayerImage from "./PlayerImage";

export default function PlayerImageByPos({
  player,
  isAnimated,
  greenBg,
  style,
}) {
  if (!player) return null;

  let pos = null;
  if (player.pos) pos = player.pos;

  let pose = PLAYER_IMAGE_POSES.PROFILE_R;
  switch (pos) {
    case "QB":
      pose = isAnimated
        ? PLAYER_IMAGE_POSES.ANIM_QB_PASS_R
        : PLAYER_IMAGE_POSES.PASS_R;
      break;
    case "RB":
      pose = isAnimated
        ? PLAYER_IMAGE_POSES.ANIM_RUN_R
        : PLAYER_IMAGE_POSES.RUN_R;
      break;
    case "WR":
      pose = isAnimated
        ? PLAYER_IMAGE_POSES.ANIM_CATCH_R
        : PLAYER_IMAGE_POSES.PROFILE_R;
      break;
    case "TE":
      pose = isAnimated
        ? PLAYER_IMAGE_POSES.ANIM_CATCH_R
        : PLAYER_IMAGE_POSES.STANCE_R;
      break;
    case "K":
      pose = isAnimated
        ? PLAYER_IMAGE_POSES.ANIM_KICK_R
        : PLAYER_IMAGE_POSES.KICK_R;
      break;
    case "DEF":
      pose = isAnimated
        ? PLAYER_IMAGE_POSES.ANIM_RUN_L
        : PLAYER_IMAGE_POSES.STANCE_L;
      break;
    default:
      console.error(`unknown pos: ${pos}`);
  }

  const newStyle = !!greenBg ? { backgroundColor: "#00ab00", ...style } : style;

  return <PlayerImage player={player} pose={pose} style={newStyle} />;
}
